Dates = require 'lib/dates'
React = require 'react'
_ = require 'underscore'
t = require('views/internal/recup-with-helpers')('trello_board_attachment')

{
  CanonicalBoard
  GenericErrorCanonicalBoard
  InvalidCanonicalBoard
  LoadingCanonicalBoard
  NetworkErrorCanonicalBoard
  NotFoundCanonicalBoard
  UnauthorizedCanonicalBoard
} = require 'views/canonical-board/canonical-board-components'

class TrelloBoardAttachmentLoading extends React.Component
  displayName: 'TrelloBoardAttachmentLoading'

  render: t.renderable ->
    t.div '.trello-board-attachment-loading', =>
      t.div '.trello-attachment-canonical-board', =>
        t.tag LoadingCanonicalBoard

class TrelloBoardAttachmentGenericError extends React.Component
  displayName: 'TrelloBoardAttachmentGenericError'

  render: t.renderable ->
    { canEdit, errorText, onRemove } = @props

    t.div '.trello-board-attachment-error', =>
      t.div '.trello-attachment-canonical-board', =>
        t.tag GenericErrorCanonicalBoard, { errorText }

      if onRemove and canEdit
        t.a '.remove-trello-attachment', { onClick: onRemove }, =>
          t.format 'remove'

class TrelloBoardAttachmentUnauthorized extends React.Component
  displayName: 'TrelloBoardAttachmentUnauthorized'

  render: t.renderable ->
    { canEdit, errorText, onRemove } = @props

    t.div '.trello-board-attachment-error', =>
      t.div '.trello-attachment-canonical-board', =>
        t.tag UnauthorizedCanonicalBoard

      if onRemove and canEdit
        t.a '.remove-trello-attachment', { onClick: onRemove }, =>
          t.format 'remove'

class TrelloBoardAttachmentSpecificError extends React.Component
  displayName: 'TrelloBoardAttachmentSpecificError'

  render: t.renderable ->
    { canEdit, error, onRemove } = @props

    t.div '.trello-board-attachment-error', =>
      t.div '.trello-attachment-canonical-board', =>
        if error == 'bad request'
          t.tag InvalidCanonicalBoard
        else if error == 'server'
          t.tag NetworkErrorCanonicalBoard
        else
          t.tag NotFoundCanonicalBoard

      if onRemove and canEdit
        t.a '.remove-trello-attachment', { onClick: onRemove }, =>
          t.format 'remove'

class TrelloBoardAttachmentComponent extends React.Component
  displayName: 'TrelloBoardAttachment'

  render: t.renderable ->
    {
      board
      canRemove
      onRemove
    } = @props

    t.div '.trello-board-attachment', =>
      t.div '.trello-attachment-canonical-board', =>
        t.tag CanonicalBoard, {
          board
        }

      if onRemove and canRemove
        t.a '.remove-trello-attachment', { onClick: onRemove }, =>
          t.format 'remove'

module.exports = {
  TrelloBoardAttachmentComponent
  TrelloBoardAttachmentGenericError
  TrelloBoardAttachmentLoading
  TrelloBoardAttachmentSpecificError
  TrelloBoardAttachmentUnauthorized
}




// WEBPACK FOOTER //
// ./app/scripts/views/attachment/trello-board-attachment-components.coffee